module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('b-modal', {
    ref: "importissuesmodal",
    attrs: {
      "id": "import-issues-modal",
      "title": "Import requirements from CSV",
      "name": "import-issues-modal",
      "size": "lg",
      "busy": _vm.loading,
      "ok-title": "Import",
      "close-title": "Cancel",
      "hide-header-close": "",
      "ok-disabled": !_vm.uuidFileName || !_vm.requirementType
    },
    on: {
      "ok": _vm.handleOk,
      "cancel": _vm.handleCancel,
      "shown": _vm.shown
    }
  }, [_c('div', {
    staticClass: "form-group"
  }, [_c('b-form-group', {
    attrs: {
      "description": "These types can be managed on the rmCloud Configuration screen"
    }
  }, [_c('multiselect', {
    attrs: {
      "options": _vm.requirementTypes,
      "loading": _vm.requirementTypesLoading,
      "allow-empty": false,
      "close-on-select": true,
      "hide-selected": false,
      "placeholder": "Select a requirement type to import these requirements as",
      "label": "name",
      "track-by": "requirement_type_id"
    },
    model: {
      value: (_vm.requirementType),
      callback: function($$v) {
        _vm.requirementType = $$v
      },
      expression: "requirementType"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "form-check"
  }, [_c('label', {
    staticClass: "form-check-label"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.specificLocation),
      expression: "specificLocation"
    }],
    staticClass: "form-check-input",
    attrs: {
      "type": "checkbox"
    },
    domProps: {
      "checked": Array.isArray(_vm.specificLocation) ? _vm._i(_vm.specificLocation, null) > -1 : (_vm.specificLocation)
    },
    on: {
      "__c": function($event) {
        var $$a = _vm.specificLocation,
          $$el = $event.target,
          $$c = $$el.checked ? (true) : (false);
        if (Array.isArray($$a)) {
          var $$v = null,
            $$i = _vm._i($$a, $$v);
          if ($$el.checked) {
            $$i < 0 && (_vm.specificLocation = $$a.concat([$$v]))
          } else {
            $$i > -1 && (_vm.specificLocation = $$a.slice(0, $$i).concat($$a.slice($$i + 1)))
          }
        } else {
          _vm.specificLocation = $$c
        }
      }
    }
  }), _vm._v("\n        Import to a specific location\n      ")])]), _vm._v(" "), (_vm.specificLocation) ? _c('folders-list', {
    attrs: {
      "folders": _vm.folders
    }
  }) : _vm._e(), _vm._v(" "), _c('input', {
    ref: "fileInput",
    attrs: {
      "type": "file",
      "id": "file_input"
    },
    on: {
      "change": function($event) {
        _vm.processFile($event)
      }
    }
  }), (_vm.uuidFileName) ? _c('icon', {
    staticStyle: {
      "color": "green",
      "margin-left": "5px"
    },
    attrs: {
      "name": "check"
    }
  }) : _vm._e(), (_vm.error) ? _c('icon', {
    staticStyle: {
      "color": "red",
      "margin-left": "5px"
    },
    attrs: {
      "name": "exclamation-circle"
    }
  }) : _vm._e(), _vm._v(" "), (_vm.error) ? _c('p', {
    staticStyle: {
      "font-weight": "bold"
    }
  }, [_vm._v(_vm._s(_vm.error))]) : _vm._e(), _vm._v(" "), _c('p', [_vm._v("Required column names: "), _c('strong', [_vm._v("Name")])]), _vm._v(" "), _c('p', [_vm._v("Optional column names: "), _c('strong', [_vm._v("ID")]), _vm._v(", "), _c('strong', [_vm._v("Description")]), _vm._v(", "), _c('strong', [_vm._v("Component/s")]), _vm._v(", "), _c('strong', [_vm._v("Status")])]), _vm._v(" "), _c('p', [_vm._v("You can also use the names of any of your custom attributes")]), _vm._v(" "), (_vm.loading) ? _c('div', {
    attrs: {
      "slot": "modal-ok"
    },
    slot: "modal-ok"
  }, [_c('icon', {
    attrs: {
      "name": "spinner",
      "pulse": ""
    }
  }), _vm._v(" Importing\n    ")], 1) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f69f6c8e"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/modals/ImportIssuesModal.vue
// module id = 1030
// module chunks = 1